<template>
<el-main class="container">
  <el-form
    label-position="top"
    label-width="80px">
    <div class="title" v-if="type === 'set'">编辑会议室</div>
    <div class="title" v-else>新增会议室</div>
    <el-form-item label="排序序号">
      <el-input
        placeholder="请输入排序序号"
        v-model.trim="body.indexNum"
        @mousewheel.native.prevent
        clearable
        class="width"
        type="number"
        maxlength="100"/>
    </el-form-item>
    <el-form-item label="会议室名称">
      <el-input
        v-model="body.title"
        placeholder="请输入会议室名称"
        clearable
        class="width"
        maxlength="100"
        type="text"/>
    </el-form-item>
    <el-form-item label="价格">
      <el-input
        v-model.trim="body.price"
        placeholder="请输入会议室单价"
        clearable
        @mousewheel.native.prevent
        type="number"
        class="width"
        maxlength="100">
          <template slot="append">/小时</template>
        </el-input>
    </el-form-item>
    <el-form-item label="面积">
      <el-input
        v-model.trim="body.area"
        placeholder="请输入会议室面积"
        clearable
        @mousewheel.native.prevent
        type="number"
        class="width"
        maxlength="100">
          <template slot="append">m²</template>
        </el-input>
    </el-form-item>
    <el-form-item label="可容纳人数">
      <el-input
        v-model.trim="body.number"
        placeholder="请输入可容纳人数"
        clearable
        @mousewheel.native.prevent
        type="number"
        class="width"
        maxlength="100"/>
    </el-form-item>
    <el-form-item label="地址">
      <el-input
        v-model="body.address"
        placeholder="请输入会议室地址"
        class="width"
        maxlength="100"/>
    </el-form-item>
    <el-form-item label="联系电话">
      <el-input
        v-model="body.linkMobile"
        placeholder="请输入联系电话"
        clearable
        class="textarea"
        maxlength="100"/>
    </el-form-item>
    <el-form-item label="所属产业">
      <el-select v-model="selectIndustry" clearable class="width">
        <el-option
          v-for="item in industryList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
          placeholder="请选择产业"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item label="预定权益说明">
      <el-input
        v-model="body.basicDescription"
        class="textarea"
        type="textarea"
        rows="6"
        maxlength="100"/>
    </el-form-item>
    <el-form-item label="预定权益">
      <el-input
        v-model="body.basicService"
        class="textarea"
        type="textarea"
        rows="6"
        maxlength="100"/>
    </el-form-item>

    <el-form-item label="增值服务">
      <el-input
        v-model="body.valueService"
        class="textarea"
        type="textarea"
        rows="6"
        maxlength="100"/>
    </el-form-item>
    <!-- <el-form-item label="会议功能说明">
      <el-input
        v-model="body.functionDescription"
        class="textarea"
        type="textarea"
        rows="6"
        maxlength="100"/>
    </el-form-item> -->
    <el-form-item :label="`场地布局图片(${layoutNum}/4)`">
      <UpLoadImg
        :img="layoutPictureList"
        :length='4'
        :size="[350, 180]"
        @get-files="getLayout"/>
    </el-form-item>
    <el-form-item :label="`封面图(${pictureNum}/1)`">
      <UpLoadImg
        tips="(638*258)"
        :img="picture"
        :size="[350, 180]"
        @get-files="getFiles"/>
    </el-form-item>
    <el-form-item :label="`轮播图(${bannersNum}/6)`">
      <UpLoadImg
        tips="(750*320)"
        :img="banners"
        :length='6'
        :size="[350, 180]"
        @get-files="getbanner"/>
    </el-form-item>
    <div class="title">介绍</div>
    <wang-editor
        ref="editor"
        @editorContent="getEditorContent"/>
    <div class="btn-box">
      <el-button @click="event().goBack()">取消</el-button>
      <el-button type="primary" @click="event().update()">保存</el-button>
    </div>
  </el-form>
</el-main>
</template>

<script>
import { addMeeting, getMeetingDetails, putMeeting } from '@/api/meeting'
import WangEditor from '@/components/Wangeditor/index'
import UpLoadImg from '@/components/upload-img'
import { getIndustrySelectList } from '@/api/industry'
export default {
  name: 'DetailsManagement',
  data() {
    return {
      type: '',
      body: {
        indexNum: null,
        title: '',
        price: '',
        area: null,
        number: null,
        address: '',
        picture: null,
        banners: [],
        introduction: '',
        basicDescription: '',//基础服务说明
        functionDescription: '',//会议功能
        industryUuid: '',
        layoutPictureList: [],
        linkMobile: '',
        basicService: '',
        valueService: ''
      },
      uuid: '',
      picture: '',
      banners: [],
      layoutPictureList: [],
      industryList: [],
      selectIndustry: '',
      layoutNum: 0,
      pictureNum: 0,
      bannersNum: 0,
    }
  },
  async created() {
    const { meta } = this.$route
    this.type = meta[meta.length - 1].url
    await this.network().getIndustrySelectList()
    await this.handler().initNetwork()
  },
  methods: {
    // 获取编辑器内容
    getEditorContent(data) {
      this.body.introduction = data
    },
    event() {
      return {
        update: () => {
          this.body.industryUuid = this.selectIndustry
          if (!this.handler().varifyBody()) return
          if (this.type === 'set') this.network().putMeeting()
          else this.network().addMeeting()
        },
        goBack: () => {
          this.$router.push('/metting-management/list-management')
        }
      }
    },
    network() {
      return {
        addMeeting: async() => {
          await addMeeting(this.body)
          this.$message({
            type: 'success',
            message: '成功'
          })
          this.$router.push('/metting-management/list-management')
        },
        getMeetingDetails: async() => {
          const { data } = await getMeetingDetails(this.uuid)
          for(let key in this.body){
            let val = data[key]
            data[key] ? this.body[key] = val : ''
          }
          this.selectIndustry = data.industryUuid
          this.$refs.editor.setHtml(data.introduction)
          this.uuid = data.uuid
          // 展示图片
          this.picture = data.picture
          this.banners = data.banners
          this.layoutPictureList = data.layoutPictureList
        },
        putMeeting: async() => {
          let data = {
            ...this.body,
            uuid: this.uuid
          }
          await putMeeting(data)
          this.$message({
            type: 'success',
            message: '成功'
          })
          this.$router.push('/metting-management/list-management')
        },
        getIndustrySelectList: async() => {
          const { data } = await getIndustrySelectList()
          data.forEach(item => {
            this.industryList.push({
              value: item.uuid,
              label: item.name
            })
          })
        }
      }
    },
    handler() {
      return {
        initNetwork: async () => {
          if (this.type === 'set') {
            this.uuid = this.$route.params.id
            await this.network().getMeetingDetails()
          }
        },
        varifyBody: () => {
          const { body } = this
          if (!body.indexNum) {
            this.$message({
              message: '请填写排序序号',
              type: 'error'
            })
            return false
          }
          if (!body.title) {
            this.$message({
              message: '请填写会议室名称',
              type: 'error'
            })
            return false
          }
          if (!body.price) {
            this.$message({
              message: '请填写价格',
              type: 'error'
            })
            return false
          }
          if (!body.area) {
            this.$message({
              message: '请填写面积',
              type: 'error'
            })
            return false
          }
          if (!body.number) {
            this.$message({
              message: '请填写可容纳人数',
              type: 'error'
            })
            return false
          }
          if (!body.address) {
            this.$message({
              message: '请填写地址',
              type: 'error'
            })
            return false
          }
          if (!body.linkMobile) {
            this.$message({
              message: '请填写联系电话',
              type: 'error'
            })
            return false
          }
          if (!body.industryUuid) {
            this.$message({
              message: '请选择产业',
              type: 'error'
            })
            return false
          }
          if (!body.basicDescription) {
            this.$message({
              message: '请填写基础服务说明',
              type: 'error'
            })
            return false
          }
          if (!body.basicService) {
            this.$message({
              message: '请填写基础服务',
              type: 'error'
            })
            return false
          }
          if (!body.valueService) {
            this.$message({
              message: '请填写增值服务',
              type: 'error'
            })
            return false
          }
          // if (!body.functionDescription) {
          //   this.$message({
          //     message: '请填写会议功能说明',
          //     type: 'error'
          //   })
          //   return false
          // }
          if (body.layoutPictureList.length === 0) {
            this.$message({
              message: '请上传场地布局图片',
              type: 'error'
            })
            return false
          }
          if (!body.picture) {
            this.$message({
              message: '请上传封面图',
              type: 'error'
            })
            return false
          }
          if (body.banners.length === 0) {
            this.$message({
              message: '请上传轮播图',
              type: 'error'
            })
            return false
          }
          if (body.introduction === '') {
            this.$message({
              message: '请填写介绍',
              type: 'error'
            })
            return false
          }
          return true
        }
      }
    },
    getFiles(file, files) {
      this.body.picture = files.length ? file.response : ''
      this.body.picture !== '' ? this.pictureNum = 1 : this.pictureNum = 0
    },
    getbanner(file, files) {
      const arr = []
      files.forEach((item) => {
        if (item.response === undefined) {
          arr.push(item.url.substring(item.url.lastIndexOf('/') + 1))
        } else {
          arr.push(item.response)
        }
      })
      this.body.banners = arr
      this.bannersNum = this.body.banners.length
    },
    getLayout(file, files) {
      this.body.layoutPictureList = []
      if(files.length > 0){
        files.forEach(item=>{
          if (item.response === undefined) {
            this.body.layoutPictureList.push(item.url.substring(item.url.lastIndexOf('/') + 1))
          } else {
            this.body.layoutPictureList.push(item.response)
          }
        })
      }
      this.layoutNum = this.body.layoutPictureList.length
    }
  },
  components: {
    UpLoadImg,
    WangEditor
  }
}
</script>

<style scoped lang="scss">
.title{
  font-size: 25px;
  margin: 30px 0;
  font-weight: bold;
}
.editor{
  width: 60%;
}
.btn-box{
  margin: 30px 0;
  display: flex;
  justify-content: center;
}
.width{
  width: 400px;
}
.textarea{
  width: 400px;
}
</style>
